exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".livestream-player-wrap[data-v-b7c91088] {\n  background-color: #232323;\n  color: white;\n  border-bottom: 1px solid rgba(155, 155, 155, 0.16);\n  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.05);\n}\n.livestream-player-wrap .sermon-player[data-v-b7c91088] {\n  width: 100%;\n}\n.livestream-image[data-v-b7c91088] {\n  height: 0;\n  overflow: hidden;\n  padding-bottom: 56.25%;\n}\n.livestream-image img[data-v-b7c91088] {\n  height: auto;\n  width: 100%;\n}", ""]);

// exports
